import Badges from './Badges';
export default Badges;